import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { LetDirective } from '@ngrx/component';

import { ResultsContent } from '../../models/results/results-content';
import { ResultsPrizeComponent } from '../results-prize/results-prize.component';
import { SingleResultsPrizeComponent } from '../single-results-prize/single-results-prize.component';

@Component({
    selector: 'tp-results-prize-group',
    templateUrl: './results-prize-group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LetDirective, ResultsPrizeComponent, SingleResultsPrizeComponent],
})
export class ResultsPrizeGroupComponent {
    @Input() showCheckButton: boolean = true;
    @Input() resultsContent: ResultsContent;
    @Input() showResultsInfo: boolean = true;
}
